import { getStore as getCLPStore } from '../store/store';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';

export default function(): CLPLabel {
    const { userLabels } = getCLPStore();
    for (let i = 0; i < userLabels.length; i++) {
        if (userLabels[i].isDefault) {
            return userLabels[i];
        }
    }
    return null;
}
